module.exports = __webpack_public_path__ + "static/media/video.fdc99c99.svg";